requirejs(['views/email-form'], function(EmailForm) {
  new EmailForm({
    el: '#cu',
    url: '/contact-us'
  });
});
define("contact-us", function(){});

